module.exports = __webpack_public_path__ + "media/images/payments/dwolla-dark-8b04e9882a8f2920cc3d4bfd7b9bdea3.svg";